export function formatTime(time: string): string {
  return time.replace(/(\d{2}):(\d{2}):(\d{2})/, '$1:$2');
}
